//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/Section.js";
let d=[[[0,"AddCover",1,0],[1,"CoverThickness",0,"Expression",0],[0,"LoadRequirements",1,0],[0,"MakeSketchInternal",1,0],[1,"SelectOutline",0,"Section",0],[0,"TextLocation",1,"Point",0],[0,"TextSize",1,0],[0,"UseCoverOffset",1,0]],[[["nEnterTextString"],"GetEnterTextString",{R_:{enterTextString:""}},0,0],[["enterTextString"],"SetEnterTextString",{},1,0]],[]];
SPLM.LineDesigner.HoleFeatureBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.HoleFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;